// extracted by mini-css-extract-plugin
export default {"center":"DeleteAccountModal-module--center--QRrq-","p":"DeleteAccountModal-module--p--UHMrq","error-message":"DeleteAccountModal-module--error-message--ydvdQ"};